import React from "react";
import { useShellTheme } from "../layout/ShellTheme";

/**
 * Scannable marketing article layout — theme-aware for dark premium customer pages.
 */
export default function ContentPageLayout({ eyebrow, title, subtitle, children, className = "" }) {
  const dark = useShellTheme() === "dark";

  return (
    <main className={`pt-10 md:pt-14 pb-24 md:pb-32 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <header className="max-w-3xl mb-12 md:mb-16">
          {eyebrow ? (
            <span
              className={`inline-block text-xs tracking-[0.25em] uppercase ${
                dark ? "text-sage/80" : "text-botanical/70"
              }`}
            >
              {eyebrow}
            </span>
          ) : null}
          <h1
            className={`font-sans font-semibold text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.1] tracking-tight ${
              dark ? "text-ivory" : "text-forest"
            }`}
          >
            {title}
          </h1>
          {subtitle ? (
            <p
              className={`mt-5 text-base md:text-lg leading-relaxed ${
                dark ? "text-sage" : "text-botanical/85"
              }`}
            >
              {subtitle}
            </p>
          ) : null}
        </header>
        <div className={dark ? "mm-dark-content" : undefined}>{children}</div>
      </div>
    </main>
  );
}
